import { Search } from '@mui/icons-material';
import { SxProps, TextField } from '@mui/material';
import React, { useState } from 'react';
import { Colors } from '../../utils/theme';

type IProps = {
  id: string;
  filter: (text: string) => void;
  additionalStyleInputProps?: SxProps;
};

const SearchInput: React.FunctionComponent<IProps> = ({
  id,
  filter,
  additionalStyleInputProps
}: IProps) => {
  const [searchValue, setSearchValue] = useState('');
  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    filter(value);
    setSearchValue(value);
  };

  // , border: 'none'
  return (
    <TextField
      id={id}
      data-testid={id}
      value={searchValue}
      onChange={handleValueChange}
      size="small"
      sx={{
        color: Colors.main,
        background: Colors.white,
        // width: '59.6%',
        width: '100%',
        height: '36px',
        borderRadius: '9px',
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            border: 'none'
          }
        }
      }}
      placeholder={'Search...'}
      InputProps={{
        endAdornment: <Search style={{ color: Colors.main, width: '18px', height: '18px' }} />,
        disableUnderline: true,
        sx: { marginTop: 'auto', marginBottom: 'auto' }
      }}
      inputProps={{
        sx: {
          ...additionalStyleInputProps
        }
      }}
      className={'custom-search'}
    />
  );
};

export default SearchInput;
